// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__M-FUL","l5":"loader_l5__tk4B8","orange":"loader_orange__FjoV1"};